import { EnvMicroDocument } from "lib-klab-core";

export const CHAT_DOCUMENT_DEV_ORIGIN =
  "https://gatewayapi-dev.klab.inclub.world";
export const CHAT_DOCUMENT_PROD_ORIGIN =
  "https://gatewayapi.klab.inclub.world";
export const CHAT_DOCUMENT_DEV_API_BASE_PATH = "/ms-document/api/v1/s3";
export const CHAT_DOCUMENT_PROD_API_BASE_PATH = "/ms-document/api/v1/s3";
// The bucket/CDN serves media URLs directly (not through the gateway). This
// origin must match the S3_BASE_URL / CHAT_MEDIA_ALLOWED_ORIGINS used by
// Document and Store respectively.
export const CHAT_MEDIA_DEV_ALLOWED_ORIGINS: readonly string[] = [
  "https://klab-erp.s3.us-east-2.amazonaws.com"
];
export const CHAT_MEDIA_PROD_ALLOWED_ORIGINS: readonly string[] = [
  "https://klab-erp.s3.us-east-2.amazonaws.com"
];

export const envDocumentLocal: EnvMicroDocument = {
  host: "",
  apiBasePath: "/api/v1/s3",
  mediaAllowedOrigins: [],
  mediaWriteMode: "blocked",
  allowLegacyMediaKeys: false,
};

export const envDocumentDev: EnvMicroDocument = {
  host: CHAT_DOCUMENT_DEV_ORIGIN,
  apiBasePath: CHAT_DOCUMENT_DEV_API_BASE_PATH,
  mediaAllowedOrigins: CHAT_MEDIA_DEV_ALLOWED_ORIGINS,
  mediaWriteMode: "receipt-required",
  allowLegacyMediaKeys: false,
};

export const envDocumentProd: EnvMicroDocument = {
  host: CHAT_DOCUMENT_PROD_ORIGIN,
  apiBasePath: CHAT_DOCUMENT_PROD_API_BASE_PATH,
  mediaAllowedOrigins: CHAT_MEDIA_PROD_ALLOWED_ORIGINS,
  mediaWriteMode: "receipt-required",
  allowLegacyMediaKeys: false,
};
